if ( typeof ProductPage !== 'function' ) {

    class ProductPage extends HTMLElement {

        constructor(){
            super();

            this.productGallery = this.querySelector('[data-js-product-gallery]');
            this.productSlider = this.querySelector('css-slider');

            this.pickupAvailabilityExtended = this.querySelector('pickup-availability-extended');

            // Gallery thumbnails
            if ( this.productSlider ) {

                if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

                    this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
                        if ( i == 0 )  {
                            elm.classList.add('active');
                        }
                        elm.addEventListener('click',e=>{
                            if ( this.productSlider.sliderEnabled ) {
                                this.productSlider.changeSlide(e.currentTarget.dataset.index);
                            } else {
                                window.scrollTo({
                                    top: this.productGallery.querySelector(`.product-gallery-item:not(.clone-slide)[data-index="${e.currentTarget.dataset.index}"]`).getBoundingClientRect().top,
                                    behavior: 'smooth'
                                });
                                this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
                            }
                        });
                    })

                    this.productSlider.addEventListener('change', e=>{
                        this.thumbnailNavigationHelper(e.target.index);
                        // Landing back on slide 0 during the load window: re-pin it
                        if ( parseInt(e.target.index, 10) === 0 ) {
                            setTimeout(()=> this.correctFirstSlide(), 60);
                        }
                    });

                }

                this.productSlider.addEventListener('change', e=>{
                    if ( this.productGallery.querySelector(`.product-gallery-item:not(.clone-slide)[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
                        if ( this.xrButton ) {
                            this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item:not(.clone-slide)[data-index="${e.target.index}"]`).dataset.mediaId);
                        }
                        setTimeout(()=>{
                            this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
                        }, 150);
                    }
                });

                // Once the shopper actually touches/scrolls the gallery, stop auto-correcting
                // so we never fight their navigation.
                this._galleryUserActed = false;
                const galleryHolder = this.productSlider.querySelector('.css-slider-holder') || this.productSlider;
                ['pointerdown','touchstart','wheel','keydown'].forEach((ev)=>{
                    galleryHolder.addEventListener(ev, ()=>{ this._galleryUserActed = true; }, { passive: true });
                });

                // Parallax
                this.productSlider.addEventListener('ready', (e)=>{
                    if ( this.firstProductGalleryIndex ) {
                        this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
                    }
                    // Make sure the initial load shows the FIRST image. Run across a few
                    // frames/timers: the variant-image jump can fire late on mobile and iOS
                    // scroll-snap only settles after layout.
                    requestAnimationFrame(()=> this.correctFirstSlide());
                    setTimeout(()=> this.correctFirstSlide(), 120);
                    setTimeout(()=> this.correctFirstSlide(), 500);
                });
                window.addEventListener('load', ()=> this.correctFirstSlide());

            }

            // Product variant event listener for theme specific logic
            this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
            if ( this.productVariants ) {

                this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
                this.onVariantChangeHandler({target:this.productVariants});

                // refresh color
                this.querySelectorAll('.product-variant__item--radio input').forEach(input=>{
                    input.addEventListener('click', () => {
                        const inputParent = input.closest('.product-variant__item--radio');
                        if ( inputParent.classList.contains('product-variant__item--color' ) ) {
                            inputParent.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = input.value;
                        }
                    })
                });

            }

            // show cart drawer when element is added to cart
            if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {

                let addToCartEnter = false;
                if ( this.querySelector('[data-js-product-add-to-cart]') ) {
                    this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
                        if ( e.keyCode == window.KEYCODES.RETURN ) {
                            addToCartEnter = true;
                        }
                    })
                }

                if ( this.querySelector('[data-js-product-form]') ) {
                    this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
                        document.getElementById('site-cart-sidebar').show();
                            if ( document.getElementById('cart-recommendations-sidebar') ) {
                            document.getElementById('cart-recommendations-sidebar').generateRecommendations();
                        }
                        if ( addToCartEnter ) {
                            setTimeout(()=>{
                                document.querySelector('#site-cart-sidebar [data-js-close]').focus();
                            }, 200);
                        }
                    });
                }

            }

            // Check for models
            const models = this.querySelectorAll('product-model');
            if ( models.length > 0 ) {
                window.ProductModel.loadShopifyXR();
                this.xrButton = this.querySelector('.product-gallery__view-in-space');
            }

            // hide buy now button if stock disabled
            const addToCartButton = this.querySelector('[data-js-product-add-to-cart][data-main-product-add-to-cart]');
            if ( addToCartButton ) {
                if ( addToCartButton.classList.contains('disabled') ) {
                    this.querySelector('product-form').classList.add('disable-buy-button');
                } else {
                    this.querySelector('product-form').classList.remove('disable-buy-button');
                }
                const buyObserver = new MutationObserver(()=>{
                    if ( addToCartButton.classList.contains('disabled') ) {
                        this.querySelector('product-form').classList.add('disable-buy-button');
                    } else {
                        this.querySelector('product-form').classList.remove('disable-buy-button');
                    }
                });
                buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
            }

        }

        // Pin the gallery to the first image during the initial-load window. On iOS the
        // variant-image jump can fire late and leave the gallery parked on a later slide
        // before the shopper has touched anything. Do NOT call resetSlider()/afterAppend():
        // re-initialising the slider broke scroll-snap navigation on iOS Safari.
        correctFirstSlide(){
            if ( ! this.productSlider || ! this.productGallery ) return;
            // Never override the shopper once they have started navigating.
            if ( this._galleryUserActed ) return;
            const holder = this.productSlider.querySelector('.css-slider-holder');
            if ( ! holder ) return;
            // With loop clones present, the first image is NOT at scroll 0 - a copy
            // of the last one sits before it. Resolve the real slide's offset.
            const firstReal = this.productGallery.querySelector('.product-gallery-item:not(.clone-slide)');
            if ( ! firstReal ) return;
            const marginLeft = parseInt( getComputedStyle(firstReal).marginLeft ) || 0;
            const left = Math.max( 0, firstReal.offsetLeft - marginLeft );
            if ( holder.scrollLeft !== left ) {
                // The holder is scroll-behavior:smooth, so a bare scrollLeft write
                // animates and the correction is visible. Unset it for the write.
                holder.classList.add('disable-snapping');
                holder.scrollLeft = left;
                // rAF does not fire in a background tab; the timeout guarantees
                // snapping comes back either way.
                var release = function(){ holder.classList.remove('disable-snapping'); };
                requestAnimationFrame(release);
                setTimeout(release, 120);
            }
            this.productSlider.index = 0;
            this.thumbnailNavigationHelper(0);
        }

        thumbnailNavigationHelper(index=0){
            this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
                if ( i == index ) {
                    elm.classList.add('active');
                    this.querySelector('.product-gallery__thumbnails-holder').scrollTo({
                        left: elm.offsetLeft - 50,
                        behaviour: 'smooth'
                    })
                } else {
                    elm.classList.remove('active');
                }
            });
        }

        onVariantChangeHandler(e){

            let variant = e.target.currentVariant;
            if ( variant ) {

                // image handling — only move the gallery when the shopper actually
                // changes the variant, never on the initial load (incl. the async
                // VARIANT_CHANGE that fires on page load). This keeps the gallery on
                // the first image = same as desktop, and matching the first thumbnail.
                if ( this._initialVariantId === undefined ) {
                    this._initialVariantId = variant.id;
                }

                if ( variant.id !== this._initialVariantId && variant.featured_media != null ) {
                    let variantImg = this.productGallery.querySelector('.product-gallery-item:not(.clone-slide)[data-media-id="' + variant.featured_media.id + '"]');
                    if ( variantImg ) {
                        if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
                            if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
                                this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
                            } else {
                                this.firstProductGalleryIndex = variantImg.dataset.index;
                            }
                        } else {
                            variantImg.scrollIntoView({behavior: 'smooth', block: 'center'});
                        }
                    }
                }

                this.querySelectorAll('.product-variant__item--color [data-selected]').forEach(elm=>{
                    elm.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = elm.value;
                });

            }

        }

    }

    if ( typeof customElements.get('product-page') == 'undefined' ) {
        customElements.define('product-page', ProductPage);
    }

}


// Hide gallery nav arrows by default, show on hover
(function() {
  function initGalleryHover() {
    const galleryContainer = document.querySelector('.css-slider--bottom-navigation');
    if (!galleryContainer) return;

    // A touch device never fires mouseenter, so this hover-reveal would leave the
    // gallery arrows permanently invisible AND unclickable - it forces opacity:0 /
    // pointer-events:none inline with !important and a MutationObserver puts that
    // straight back whenever anything tries to change it. Skip the whole thing
    // where there is no hover; CSS keeps the arrows visible there instead.
    if (window.matchMedia && window.matchMedia('(hover: none)').matches) return;

    const getNavBtns = () => document.querySelectorAll(
      '.pdp-gallery-nav--prev, .pdp-gallery-nav--next, .custom-gallery-arrow--prev, .custom-gallery-arrow--next'
    );

    function hideButtons() {
      getNavBtns().forEach(btn => {
        btn.style.setProperty('opacity', '0', 'important');
        btn.style.setProperty('pointer-events', 'none', 'important');
        btn.style.setProperty('transition', 'opacity 0.25s ease', 'important');
      });
    }

    function showButtons() {
      getNavBtns().forEach(btn => {
        btn.style.setProperty('opacity', '1', 'important');
        btn.style.setProperty('pointer-events', 'auto', 'important');
        btn.style.setProperty('transition', 'opacity 0.25s ease', 'important');
      });
    }

    // MutationObserver to keep buttons hidden when scripts re-apply inline styles
    let isHovering = false;
    const observer = new MutationObserver(() => {
      if (!isHovering) hideButtons();
    });

    getNavBtns().forEach(btn => {
      observer.observe(btn, { attributes: true, attributeFilter: ['style'] });
    });

    galleryContainer.addEventListener('mouseenter', () => { isHovering = true; showButtons(); });
    galleryContainer.addEventListener('mouseleave', () => { isHovering = false; hideButtons(); });

    hideButtons(); // Apply on init
  }

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryHover);
  } else {
    // Slight delay to allow slider script to inject buttons first
    setTimeout(initGalleryHover, 300);
  }
})();